import { FETCH_APP_CONFIG } from 'store/actionTypes/generalActionsType'
import { getConfigRequest } from '../../utils/generalService'

export const fetchAppConfig = () => async (dispatch) => {
  const res = await getConfigRequest()
  dispatch({ type: FETCH_APP_CONFIG, payload: res })
}
